module.exports = __webpack_public_path__ + "static/media/111IntroVid789.2d6c0675.mp4";